<template>
  <!--  -->
  <div class="fade_carousel_wrap">
    <div class="fade-carousel"
         @mouseenter="pauseAutoPlay"
         @mouseleave="resumeAutoPlay">
      <!-- 图片容器 -->
      <div class="carousel-viewport">
        <div class="carousel-track">
          <div
            v-for="(item, index) in items"
            :key="index"
            class="slide"
            :class="{ active: currentIndex === index }"
          >
            <img
              :src="item.img"
              class="responsive-image"
              :alt="item.title || 'carousel image'"
            >
          </div>
        </div>
      </div>

        <!-- 控制按钮 -->
      <button class="arrow prev" @click="prevSlide">&lt;</button>
      <button class="arrow next" @click="nextSlide">&gt;</button>

        <!-- 指示器 -->
      <div class="indicators">
        <span v-for="(item, index) in items"
              :key="index"
              :class="{ active: currentIndex === index }"
              @click="currentIndex = index">
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
      validator: value => value.every(item => item.img)
    },
    interval: {
      type: Number,
      default: 5000
    },
    autoplay: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      currentIndex: 0,
      timer: null
    }
  },

  mounted() {
    this.startAutoPlay()
  },

  beforeDestroy() {
    this.clearTimer()
  },

  methods: {
    startAutoPlay() {
      if (!this.autoplay) return
      this.timer = setInterval(() => {
        this.nextSlide()
      }, this.interval)
    },

    pauseAutoPlay() {
      this.clearTimer()
    },

    resumeAutoPlay() {
      this.startAutoPlay()
    },

    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },

    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.items.length
    },

    prevSlide() {
      this.currentIndex =
        (this.currentIndex - 1 + this.items.length) % this.items.length
    }
  }
}
</script>

<style scoped lang="scss">
@supports not (aspect-ratio: 16/9) {
  /* 旧浏览器备用方案 */
  .carousel-viewport {
    height: 0;
    padding-bottom: 56.25%;
  }
}

.fade-carousel {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 400px;
  max-height: 730px;
  display: grid; /* 使用网格布局消除空隙 */
}

.carousel-viewport {
  position: relative;
  width: 100%;
  min-height: 400px;
  max-height: 730px;
  aspect-ratio: 16/9; /* 现代浏览器直接使用宽高比 */
  overflow: hidden;
  .carousel-track {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    .slide {
      position: absolute;
      width: 100%;
      height: 100%;
      opacity: 0;
      transition: opacity 1s ease-in-out;
      .responsive-image {
        width: 100%;
        height: 100%;
        max-height: 730px;
        object-fit: cover; /* 保持图片比例填充 */
        object-position: center;
      }
    }
    .slide.active {
      opacity: 1;
    }

  }
}

.arrow {
  position: absolute;
  top: 55%;
  transform: translateY(-50%);
  background: rgba(0,0,0,0.3);
  color: white;
  border: none;
  padding: 15px;
  cursor: pointer;
  transition: background 0.3s;
}

.arrow:hover {
  background: rgba(0,0,0,0.7);
}

.prev {
  left: 10px;
}

.next {
  right: 10px;
}

.indicators {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
    span {
      width: 12px;
      height: 6px;
      border-radius: 30px;

      background: rgba(255,255,255,0.5);
      cursor: pointer;
      transition: all 0.3s;
    }
  span.active {
    width: 24px;
    background: rgba(255,255,255,0.9);
    transform: scale(1.2);
  }
}
</style>
